import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useI18n } from "../../../../../../../contexts/i18n.js";
import { Notices } from "../../../../../../common/notices.js";
import { FormServiceFieldTechnicalDefinitionsLayout } from "../table.js";
const FormServiceFieldTechnicalDefinitionsCookieName = ({ field, readOnly })=>{
    const { __, _i } = useI18n();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                ...FormServiceFieldTechnicalDefinitionsLayout,
                name: [
                    field.name,
                    "name"
                ],
                rules: [
                    {
                        required: true,
                        message: __("Please provide a technical cookie name!")
                    }
                ],
                children: /*#__PURE__*/ _jsx(Input, {
                    disabled: readOnly
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.technicalDefinitions[field.name]?.name !== nextValues.technicalDefinitions[field.name]?.name,
                children: ({ getFieldValue })=>{
                    const cookieName = getFieldValue([
                        "technicalDefinitions",
                        field.name,
                        "name"
                    ]);
                    const notSupportedCookieNamePlaceholders = [
                        /\[/gm,
                        [
                            /([{]+)/gm,
                            (match)=>match.length === 1
                        ],
                        /\(/gm
                    ];
                    return notSupportedCookieNamePlaceholders.filter((r)=>Array.isArray(r) ? r[0].test(cookieName) && cookieName.match(r[0]).filter(r[1]).length > 0 : r.test(cookieName)).length > 0 && /*#__PURE__*/ _jsx(Notices, {
                        notices: [
                            {
                                message: _i(__("Are you sure this is the name of the cookie? It seems like you are using a placeholder that is not supported. Please use an asterisk ({{code}}*{{/code}}) as a placeholder if the cookie name is dynamically composed."), {
                                    code: /*#__PURE__*/ _jsx("code", {})
                                }),
                                severity: "warning"
                            }
                        ]
                    });
                }
            })
        ]
    });
};
export { FormServiceFieldTechnicalDefinitionsCookieName };
